module.exports = __webpack_public_path__ + "21a2140203d1d500ba7712349b7a3779.png";